import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
export type ActionItemLinkedToEntities_KeyResultType_Fragment = { __typename: 'KeyResultType', id: string, name: string, type: Types.OkrTypeEnum };

export type ActionItemLinkedToEntities_MeetingType_Fragment = { __typename: 'MeetingType', id: string, meetingName?: string | null, meetingType: Types.MeetingTypeEnum, participants?: Array<{ id: string, name?: string | null }> | null };

export type ActionItemLinkedToEntities_ObjectiveType_Fragment = { __typename: 'ObjectiveType', id: string, name: string, type: Types.OkrTypeEnum, categoryConfig: { type: Types.ObjectiveTypeEnum } };

export type ActionItemLinkedToEntities_PeerFeedbackSchema_Fragment = { __typename: 'PeerFeedbackSchema', id: string, senderUser?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, receiverUser?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };

export type ActionItemLinkedToEntitiesFragment = ActionItemLinkedToEntities_KeyResultType_Fragment | ActionItemLinkedToEntities_MeetingType_Fragment | ActionItemLinkedToEntities_ObjectiveType_Fragment | ActionItemLinkedToEntities_PeerFeedbackSchema_Fragment;


export type ActionItemLinkedToEntitiesFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ActionItemLinkedToEntitiesFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionItemLinkedToEntities on ActionItemLinkedToEntityPayloadUnion {
  __typename
  ... on ObjectiveType {
    id
    name
    type
    categoryConfig {
      type
    }
  }
  ... on KeyResultType {
    id
    name
    type
  }
  ... on MeetingType {
    id
    meetingName: name
    meetingType: type
    participants {
      id
      name
    }
  }
  ... on PeerFeedbackSchema {
    id
    senderUser {
      ...User
    }
    receiverUser {
      ...User
    }
  }
}
    `;